import { Component, OnInit, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  routeName: string;
  @HostBinding('class')
  public footerStyle: string;

  constructor(private router: Router) {
    this.routeName = window.location.pathname;
  }

  ngOnInit(): void {
  }

  navigateTo(page: any) {
    this.router.navigate([page]);
  }

  ngDoCheck() {
    this.routeName = window.location.pathname;
    if (this.router.url.indexOf('/reset-password') > -1 || this.router.url.indexOf('/signup-billing') > -1) {
      this.footerStyle = 'fixedFooter';
    } else {
      this.footerStyle = 'normalFooter';
    }
  }
}
